import React from 'react'
import ArenaTable from './ArenaTable';
import { TableObject } from './TableObject';

export default function Arena22Table({ totalTables, toggleTableSelection, BaseURL, translate, isAds }) {
    return <div className="bookingTableContainer px-5" style={{ direction: 'ltr' }}>
        <div className="bookingTableCenter">
            <div className="BookingTableArena" style={{ direction: 'ltr' }}>
                <img
                    style={{ width: '99%', height: 'unset', aspectRatio: 'unset', background: '#A67B52' }}
                    src={`${BaseURL}/assets/img/Arena22Table.png`}
                    alt="Horse Arena" />
            </div>
            {/* <span className='text-danger text-center bold' style={{ width: 110, display: 'block' }}>{translate('web.displayScreen', 'Display Screen')}<br /> 5 × 9 m </span> */}
        </div>
        <div className="bookingTablesRow withVIPSection" style={{ paddingLeft: 0 }}>
            {totalTables
                .filter((item, index) => item.tableNo > 0 && item.tableNo < 7).reverse()
                .map((item, index) => (
                    index < 5 &&
                    <ArenaTable
                        isAdvertising={true}
                        key={item.tableNo}
                        tableNumber={item.tableLetter}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)}
                        style={{ marginRight: index == 4 ? '50px' : '' }}
                    />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables

                .filter((item, index) => item.tableNo > 5 && item.tableNo < 12).reverse()
                .map((item, index) => (
                    index < 5 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableLetter}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)}
                        style={{ marginLeft: index == 0 ? '50px' : '' }}

                    />
                ))}
        </div>
        <div className="bookingTablesRow withVIPSection secondVIPRow" style={{ paddingLeft: 0 }}>
            {totalTables
                .filter((item, index) => item.tableNo > 10 && item.tableNo < 23).reverse()
                .map((item, index) => (
                    index < 6 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableLetter}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)}
                    // style={{ marginRight: index == 3 && '25px' || index == 5 && '55px' }}
                    />
                ))}
            <div className="vipSection">{translate('web.vvipPlatForm', 'VVIP Platform')}</div>
            {totalTables
                .filter((item, index) => item.tableNo > 16 && item.tableNo < 23).reverse()
                .map((item, index) => (
                    index < 6 &&
                    <ArenaTable
                        key={item.tableNo}
                        tableNumber={item.tableLetter}
                        tablePrice={item.price}
                        state={TableObject.fromRaw(item).state()}
                        onClick={() => toggleTableSelection(item.id, item.price)}
                    // style={{ marginLeft: index == 0 && '5px' || index == 4 && '25px' }}
                    />
                ))}
        </div>
        <div className="bookingTablesRow" style={{ paddingLeft: 0 }}>
            <div style={{ marginLeft: 0, textAlign: 'center', maxWidth: 40, marginTop: -40 }}>
                <div style={{ width: 20, height: 10, background: '#409A97' }} />
                <div style={{ marginLeft: -10, }}>
                    <i class="fa-solid fa-up-long" style={{ color: '#409A97' }}></i>
                </div>
                <div style={{ fontSize: 13, width: 125, marginLeft: '-0px', textAlign: 'left' }}>{translate('web.audienceEntrance', 'Audience Entrance')}</div>
            </div>
            <div style={{ marginLeft: 260, textAlign: 'center', maxWidth: 40, }}>
                <div style={{ width: 20, height: 10, background: '#dc3545' }} />
                <div style={{ marginLeft: -11, }}>
                    <i class="fa-solid fa-up-long" style={{ color: '#dc3545' }}></i>
                </div>
                <div style={{ fontSize: 13, marginLeft: '-45px', width: 125, }}>{translate('web.VIPEntrance', 'VIP Entrance')}</div>
            </div>
            <div style={{ marginLeft: 440, textAlign: 'center', maxWidth: 40, marginTop: -40 }}>
                <div style={{ width: 20, height: 10, background: '#409A97' }} />
                <div style={{ marginLeft: -10, }}>
                    <i class="fa-solid fa-up-long" style={{ color: '#409A97' }}></i>
                </div>
                <div style={{ fontSize: 13, width: 125, marginLeft: '-60px', textAlign: 'left' }}>{translate('web.audienceEntrance', 'Audience Entrance')}</div>
            </div>
        </div>
    </div>;
}
